/*
  Cadeaux de palier, version du 23/09/2026.

  Ajoute et retire tout seul les produits cadeaux à 0 € quand le panier franchit un
  seuil, dans un sens comme dans l'autre. Aucune remise n'est utilisée : le prix est
  zéro par construction, donc la caisse ne peut pas contredire la jauge.

  Prudence :
    - le total servant de base EXCLUT les lignes cadeaux, sinon un cadeau pourrait
      maintenir le panier au-dessus du seuil ;
    - une seule synchronisation à la fois, sinon les appels se marchent dessus ;
    - si l'ajout échoue (produit retiré de la vente, rupture), on ne casse rien :
      le panier reste valide, le client ne voit simplement pas le cadeau.
*/
(function () {
  function config() {
    return (window.__bcPaliers && window.__bcPaliers.paliers) || [];
  }
  var enCours = false;

  function variantes() {
    return config().map(function (p) { return p.variante; }).filter(Boolean);
  }

  function baseHorsCadeaux(panier) {
    var cadeaux = variantes();
    return panier.items.reduce(function (somme, ligne) {
      if (cadeaux.indexOf(ligne.variant_id) !== -1) return somme;
      return somme + ligne.original_line_price;
    }, 0);
  }

  function json(url, corps) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(corps)
    }).then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); });
  }

  function rafraichir() {
    if (window.liquidAjaxCart && typeof window.liquidAjaxCart.get === 'function') {
      window.liquidAjaxCart.get();
    }
  }

  function synchroniser() {
    if (enCours || !config().length) return Promise.resolve();
    enCours = true;
    var modifie = false;
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (panier) {
        var base = baseHorsCadeaux(panier);
        var cadeaux = variantes();
        /* 22/10/2026 : en Black Week (mode remise du module bc-temps-fort), aucun cadeau de palier ; ceux déjà au
           panier sont retirés. */
        var suspendus = window.bcTempsFort && window.bcTempsFort.remiseActive && window.bcTempsFort.remiseActive(panier);
        var merites = suspendus ? [] : config()
          .filter(function (p) { return p.variante && base >= p.seuil; })
          .map(function (p) { return p.variante; });

        var presents = panier.items.filter(function (l) { return cadeaux.indexOf(l.variant_id) !== -1; });

        var chaine = Promise.resolve();
        presents.forEach(function (ligne) {
          var garder = merites.indexOf(ligne.variant_id) !== -1;
          if (!garder || ligne.quantity !== 1) {
            modifie = true;
            chaine = chaine.then(function () {
              return json('/cart/change.js', { id: String(ligne.key), quantity: garder ? 1 : 0 });
            });
          }
        });

        var manquants = merites.filter(function (v) {
          return !presents.some(function (l) { return l.variant_id === v; });
        });
        if (manquants.length) {
          modifie = true;
          chaine = chaine.then(function () {
            return json('/cart/add.js', {
              items: manquants.map(function (v) {
                return { id: v, quantity: 1, properties: { '_cadeau_palier': 'oui' } };
              })
            });
          });
        }
        return chaine;
      })
      .catch(function () { /* on ne casse jamais le panier du client */ })
      .then(function () {
        enCours = false;
        if (modifie) rafraichir();
      });
  }

  document.addEventListener('liquid-ajax-cart:request-end', function () {
    setTimeout(synchroniser, 60);
  });
  if (document.readyState === 'complete') {
    setTimeout(synchroniser, 800);
  } else {
    window.addEventListener('load', function () { setTimeout(synchroniser, 800); });
  }
})();
